import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Output,
	ViewChild,
} from '@angular/core';

@Component({
	selector: 'contact-actions-mobile',
	templateUrl: './contact-actions-mobile.component.html',
	styleUrls: ['./contact-actions-mobile.component.scss'],
})
export class ContactActionsMobileComponent {
	constructor() {}

	@ViewChild('actions_menu', { read: ElementRef }) actionsMenu: ElementRef;

	@Output() onScheduleClick = new EventEmitter();
	@Output() onEditClick = new EventEmitter();
	@Output() onChatClick = new EventEmitter();

	public isOpen = false;

	@HostListener('document:mousedown', ['$event'])
	onGlobalClick(event): void {
		if (!this.actionsMenu?.nativeElement.contains(event.target)) {
			this.toggleActionsMenu(false);
		}
	}
	toggleActionsMenu(value) {
		this.isOpen = value;
	}
}
